// extracted by mini-css-extract-plugin
export default {"instruction-wrapper":"styles_instruction-wrapper__sScEz"};